<template>
  <div style="position: relative">
    <mx-preloader style="top: -7px; background-color: #ffffff; padding-top: 60px" :loader-status="preloader" :logo="false"/>
    <v-autocomplete
        v-model="result"
        :disabled="isUpdating"
        :items="employees"
        outlined
        chips
        color="blue-grey lighten-2"
        :label="$t('document.employee.select')"
        item-text="name"
        item-value="id"
        multiple
        hide-details
    >

      <template v-slot:selection="data">
        <v-chip style="height: 48px; padding: 0 18px 0 14px;" label v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="remove(data.item)">
<!--          <v-avatar left tile width="30" height="40">-->
            <v-img style="width: 30px; height: 35px; margin-right: 10px;" class="rounded" :src="data.item.avatar === null ? '/assets/images/avatar.jpg' : options.avatar_url + data.item.avatar"></v-img>
<!--          </v-avatar>-->
          <div style="display: flex; flex-direction: column; margin: 0 10px 0 0;">
            <strong>{{ data.item.first_name }} {{ data.item.last_name }}</strong>
<!--            <small style="display: block; margin-top: -4px;">{{ data.item.gender }}</small>-->
          </div>
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-avatar tile>
            <v-img class="rounded" :src="data.item.avatar === null ? '/assets/images/avatar.jpg' : options.avatar_url + data.item.avatar"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.first_name }} {{ data.item.last_name }}
            </v-list-item-title>
            <v-list-item-subtitle v-html="data.item.group"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    selected: {
      type: Array,
      default: function () {
        return []
      },
    }
  },
  data() {
    return {
      preloader: true,
      autoUpdate: true,
      result: [],
      isUpdating: false,
      name: 'Midnight Crew',
      employees: [],
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    result() {
     this.resultSelect()
    },
  },
  created() {
    this.result = this.selected

    this.$store.dispatch('employees', this.page).then(() => {
      this.employees = this.$store.getters.employees.data.map(employee => {
        employee.name = employee.first_name + employee.last_name
        return employee
      })

      setTimeout(() => {
        this.preloader = false
      },300)

      this.resultSelect()
    })
  },
  methods: {
    remove (item) {
      const index = this.result.indexOf(item.id)
      if (index >= 0) this.result.splice(index, 1)
    },
    resultSelect() {
      this.$emit('result', this.result)
    }
  },
}
</script>
